<template>
  <v-form v-model="valid" ref="mainForm">
    <subheadline code="titre-etape-3.1"></subheadline>

    <opq-catalogue
      code="renseignements-analyse-demande"
      v-model="sasAutoInspection3.renseignementsAnalyseDemande"
      :live="liveSasAutoInspection3(15603)"
    ></opq-catalogue>

    <opq-memo code="elements-requis" v-model="sasAutoInspection3.elementsRequis" :live="liveSasAutoInspection3(15604)"></opq-memo>

    <opq-catalogue code="contexte-travail" v-model="sasAutoInspection3.contexteTravail" :live="liveSasAutoInspection3(15605)"></opq-catalogue>

    <opq-memo
      code="contexte-travail-details"
      v-model="sasAutoInspection3.contexteTravailDetails"
      :live="liveSasAutoInspection3(15606)"
      optional
    ></opq-memo>

    <opq-catalogue code="pertinence-mandat" v-model="sasAutoInspection3.pertinenceMandat" :live="liveSasAutoInspection3(15607)"></opq-catalogue>

    <opq-memo code="pertinence-mandat_ex" v-model="sasAutoInspection3.pertinenceMandatExemple" :live="liveSasAutoInspection3(15608)"></opq-memo>

    <opq-catalogue
      code="comprehension-attentes"
      v-model="sasAutoInspection3.comprehensionAttentes"
      :live="liveSasAutoInspection3(15609)"
    ></opq-catalogue>

    <opq-memo
      code="comprehension-attentes-details"
      v-model="sasAutoInspection3.comprehensionAttentesDetails"
      :live="liveSasAutoInspection3(15610)"
    ></opq-memo>

    <opq-catalogue code="donnees-a-recueillir" v-model="sasAutoInspection3.donneesARecueillir" :live="liveSasAutoInspection3(15611)"></opq-catalogue>

    <opq-catalogue code="justesse-conclusions" v-model="sasAutoInspection3.justesseConclusions" :live="liveSasAutoInspection3(15612)"></opq-catalogue>

    <opq-catalogue code="suites-appropriees" v-model="sasAutoInspection3.suitesAppropriees" :live="liveSasAutoInspection3(15613)"></opq-catalogue>

    <opq-catalogue
      code="litterature-scientifique"
      v-model="sasAutoInspection3.litteratureScientifique"
      :live="liveSasAutoInspection3(15614)"
    ></opq-catalogue>

    <opq-memo code="litterature-detail" v-model="sasAutoInspection3.litteratureDetail" :live="liveSasAutoInspection3(15615)"></opq-memo>

    <opq-catalogue
      code="particularites-moyens"
      v-model="sasAutoInspection3.particularitesMoyens"
      :live="liveSasAutoInspection3(15616)"
    ></opq-catalogue>

    <opq-catalogue
      code="systeme-classification"
      v-model="sasAutoInspection3.systemeClassification"
      :live="liveSasAutoInspection3(15617)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estSystemeClassification"
      code="systeme-precisez"
      v-model="sasAutoInspection3.systemePrecisez"
      :live="liveSasAutoInspection3(15618)"
      multiple
    ></opq-catalogue>

    <opq-text-field
      :opq-if="estSystemeClassification && estSystemeClassificationAutre"
      code="systeme-precisez2"
      v-model="sasAutoInspection3.systemePrecisez2"
      :live="liveSasAutoInspection3(15619)"
    ></opq-text-field>

    <opq-memo code="conclusions-exemple" v-model="sasAutoInspection3.conclusionsExemple" :live="liveSasAutoInspection3(15620)"></opq-memo>

    <opq-catalogue code="correction-protocole" v-model="sasAutoInspection3.correctionProtocole" :live="liveSasAutoInspection3(15621)"></opq-catalogue>

    <opq-memo code="instruments-mesure" v-model="sasAutoInspection3.instrumentsMesure" :live="liveSasAutoInspection3(15622)"></opq-memo>

    <opq-catalogue
      code="pertinence_intervention"
      v-model="sasAutoInspection3.pertinenceIntervention"
      :live="liveSasAutoInspection3(15623)"
    ></opq-catalogue>

    <opq-catalogue
      code="communication-appropriee-conclusions"
      v-model="sasAutoInspection3.communicationApproprieeConclusions"
      :live="liveSasAutoInspection3(15624)"
    ></opq-catalogue>

    <opq-memo
      code="difficulte-evaluation-exemple"
      v-model="sasAutoInspection3.difficulteEvaluationExemple"
      :live="liveSasAutoInspection3(15625)"
    ></opq-memo>

    <opq-memo code="bon-coup" v-model="sasAutoInspection3.bonCoup" :live="liveSasAutoInspection3(15626)"></opq-memo>

    <subheadline code="titre-etape-3.2"></subheadline>

    <opq-catalogue code="intervention" v-model="sasAutoInspection3.effectueInterventions" :live="liveSasAutoInspection3(15645)"></opq-catalogue>

    <opq-catalogue code="mandat-etabli" v-model="sasAutoInspection3.mandatEtabli" :live="liveSasAutoInspection3(15628)"></opq-catalogue>

    <opq-catalogue code="mission-organisation" v-model="sasAutoInspection3.missionOrganisation" :live="liveSasAutoInspection3(15629)"></opq-catalogue>

    <opq-catalogue
      code="objectifs-intervention"
      v-model="sasAutoInspection3.objectifsIntervention"
      :live="liveSasAutoInspection3(15630)"
    ></opq-catalogue>

    <opq-catalogue code="facteurs-incidence" v-model="sasAutoInspection3.facteursIncidence" :live="liveSasAutoInspection3(15631)"></opq-catalogue>

    <opq-catalogue
      code="communication-appropriee-questions"
      v-model="sasAutoInspection3.communicationApproprieeQuestions"
      :live="liveSasAutoInspection3(15632)"
    ></opq-catalogue>

    <opq-catalogue
      code="objectifs-intervention-respect"
      v-model="sasAutoInspection3.objectifsInterventionRespect"
      :live="liveSasAutoInspection3(15633)"
    ></opq-catalogue>

    <opq-catalogue
      code="renseignements-progres"
      v-model="sasAutoInspection3.renseignementsProgres"
      :live="liveSasAutoInspection3(15634)"
    ></opq-catalogue>

    <opq-catalogue
      code="partage-information-pertinente"
      v-model="sasAutoInspection3.partageInformationPertinente"
      :live="liveSasAutoInspection3(15635)"
    ></opq-catalogue>

    <opq-catalogue code="evaluation-evolution" v-model="sasAutoInspection3.evaluationEvolution" :live="liveSasAutoInspection3(15636)"></opq-catalogue>

    <opq-catalogue
      code="evaluation-evolution-outils"
      v-model="sasAutoInspection3.evaluationEvolutionOutils"
      :live="liveSasAutoInspection3(15637)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estEvaluationEvolutionOutils"
      code="evaluation-evolution-outils-details"
      v-model="sasAutoInspection3.evaluationEvolutionOutilsDetails"
      :live="liveSasAutoInspection3(15638)"
    ></opq-memo>

    <opq-memo
      :opq-if="estEvaluationEvolutionOutils"
      code="evaluation-evolution-exemple"
      v-model="sasAutoInspection3.evaluationEvolutionExemple"
      :live="liveSasAutoInspection3(15639)"
    ></opq-memo>

    <opq-catalogue code="discussion-progres" v-model="sasAutoInspection3.discussionProgres" :live="liveSasAutoInspection3(15640)"></opq-catalogue>

    <opq-memo code="difficultes-frequentes" v-model="sasAutoInspection3.difficultesFrequentes" :live="liveSasAutoInspection3(15643)"></opq-memo>

    <opq-memo code="nature-interventions" v-model="sasAutoInspection3.natureInterventions" :live="liveSasAutoInspection3(15641)"></opq-memo>

    <opq-memo code="bon-coup-pratique" v-model="sasAutoInspection3.bonCoupPratique" :live="liveSasAutoInspection3(15644)"></opq-memo>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasAutoInspection3() {
      return this.sas.sasAutoIP3
    },

    estSystemeClassification() {
      return this.estOui(this.sasAutoInspection3.systemeClassification)
    },

    estSystemeClassificationAutre() {
      if (this.sasAutoInspection3.systemePrecisez) {
        return this.sasAutoInspection3.systemePrecisez.some((e) => this.getCatalogueCodeById(15618, e) == "4")
      }
      return false
    },

    estEvaluationEvolutionOutils() {
      return this.estOui(this.sasAutoInspection3.evaluationEvolutionOutils)
    }
  },

  methods: {
    liveSasAutoInspection3(cle) {
      return { endpoint: "/sas-auto-inspection-3/", cle: cle, fileId: this.sasAutoInspection3.id }
    }
  }
}
</script>

<style>
</style>